import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import "./section.scss";

export default class Section extends Component {
  render() {
    return (
      <React.Fragment>
        <section
          className="section section-growing-hormone"
          data-image-src=""
          id="growing-hormone"
        >
          <div className="bg-growing-hormone growing-hormone-half">
            <div className="display-table">
              <div className="display-table-cell">
                <Container>
                  <Row className="justify-content-center">
                    <Col md={12} lg={6} className="section-growing-hormone-description text-white">
                      <h1 className="growing-hormone-title">
                        Hormônio<br/>
                        do crescimento
                      </h1>
                    </Col>
                    <Col className="content-height" md={12} lg={6}></Col>
                  </Row>
                </Container>
              </div>
            </div>
          </div>
        </section>

      </React.Fragment>
    );
  }
}
